import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TextField, Box } from '@material-ui/core';

import moment from 'moment';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { groupBy } from 'lodash';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  getRebateProgrameList,
  getUnallocatedBalanceReports,
  setPaginationIndex,
} from '../store/action';
import { UnallocatedBalanceReportTableHead } from './tableHeads';
import PaginationBox from './PaginationBox';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import { exportAllPDF } from '../../../../SharedModules/pdfExport/exportAll';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import {
  PAGINATION_EMPTY_ERR,
  PAGINATION_NEGATIVE_ERR,
  PAGINATION_OVER_TOTAL_ERR,
} from '../../../../SharedModules/Errors/constantMessageData';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import { handleCommaSeparatedAmount } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';

const UnallocatedBalanceDisplay = () => {
  const dispatch = useDispatch();
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const {
    isLoading,
    displayObj: {
      searchResult = [],
      used,
      unused,
      lcb,
      opmt,
      rebateProgramName,
      rebateProgram,
      selectedRows,
      countValue,
    },
    exportAllData: exportAllDataValue,
  } = useSelector((state) => state?.sharedState?.UnallocatedBalanceReducer);
  const rebateProgramNameValue = rebateProgramName;

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [rows, setRows] = React.useState(searchResult);
  const [count, setCount] = React.useState(countValue);
  const [exportAllClicked, setExportAllClicked] = useState(false);
  const [paginationArray, setPaginationArray] = React.useState([
    ...Array(selectedRows.length).keys(),
  ]);
  const [errorMessages, setErrorMessages] = React.useState([]);
  const [columnApi, setColumnApi] = React.useState(null);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [exportAllData, setExportAllData] = useState(exportAllDataValue);
  const changeFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  const handleClick = (type, value) => {
    dispatch(clearReduxForFilterAndSort('/unallocated-balance-report'));
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
    }

    if (type === 'change') {
      // if (value < 1 || value > paginationArray.length) {
      //   dispatch(setPaginationIndex(paginationArray.length));
      // } else {
      if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
      else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
      else if (value > paginationArray.length)
        setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
      else {
        setErrorMessages([]);
        dispatch(setPaginationIndex(value));
      }
    }
  };

  const handleBlur = (value) => {
    dispatch(clearReduxForFilterAndSort('/unallocated-balance-report'));
    // if (
    //   value < 1 ||
    //   parseInt(value) > paginationArray.length ||
    //   value === '' ||
    //   isNaN(value)
    // ) {
    //   dispatch(setPaginationIndex(0));
    //   setTimeout(() => {
    //     value < 1
    //       ? dispatch(setPaginationIndex(1))
    //       : dispatch(setPaginationIndex(paginationArray.length));
    //   }, 20);
    // } else {
    if (!value) setErrorMessages([PAGINATION_EMPTY_ERR]);
    else if (value < 1) setErrorMessages([PAGINATION_NEGATIVE_ERR]);
    else if (value > paginationArray.length)
      setErrorMessages([PAGINATION_OVER_TOTAL_ERR]);
    else {
      setErrorMessages([]);
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };


  React.useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);

  React.useEffect(() => {
    if (selectedRows[count - 1]?.mfgId) {
      dispatch(
        getUnallocatedBalanceReports({
          asMfg: [selectedRows[count - 1]?.mfgId],
          alUsed: used && unused ? 2 : used ? 0 : 1,
          asType: lcb && opmt ? 'ALL' : lcb ? 'LCB' : 'OPMT',
          asRpc: rebateProgram,
        })
      );
    }
  }, [count]);

  const [exportFileName, setExportFileName] = React.useState(null);
  const exportAllTpPDF = (name) => {
    setExportFileName(name);
    setExportAllClicked(true);
    dispatch(
      getUnallocatedBalanceReports({
        asMfg: selectedRows.map((item) => item.mfgId),
        alUsed: used && unused ? 2 : used ? 0 : 1,
        asType: lcb && opmt ? 'ALL' : lcb ? 'LCB' : 'OPMT',
        asRpc: rebateProgram,
      })
    );
  };
  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';
  let fourthInfo = '';
  // const { used, unused, lcb, opmt, rebateProgramName = '' } = slectedInfo;
  const balanceStatus =
    used && unused ? 'Used, Unused' : used ? 'Used' : unused ? 'Unused' : '';
  const balanceType =
    lcb && opmt ? 'LCB, OPMT' : lcb ? 'LCB' : opmt ? 'OPMT' : '';

  firstInfo = `Mfg: ${selectedRows[count - 1]?.mfgName} (${
    selectedRows[count - 1]?.mfgId
  })`;
  secondInfo = balanceType ? `Balance Type: ${balanceType}` : '';
  thirdInfo = rebateProgramNameValue;
  fourthInfo = balanceStatus ? `Balance Status: ${balanceStatus}` : '';
  useEffect(() => {
    let data = exportAllDataValue;
    setExportAllData(exportAllDataValue);
    data = data.map((val, i) => {
      return {
        ...val,
        origReceivedDt: val?.origReceivedDt
          ? moment(val.origReceivedDt, 'DD-MMM-YYYY').format('MM/DD/YYYY')
          : val.origReceivedDt,
        allocatedReceivedDt: val?.allocatedReceivedDt
          ? moment(val.allocatedReceivedDt, 'DD-MMM-YYYY').format('MM/DD/YYYY')
          : val.allocatedReceivedDt,
      };
    });
    const mapping = data.reduce((acc, item) => {
      acc[item.mfgId] = `${item.mfgName} (${item.mfgId})`;
      return acc;
    }, {});
    const groupedData = groupBy(data, 'mfgId');
    for (const key in groupedData) {
      groupedData[key].sort((a, b) =>
        a.origCheckIssuer > b.origCheckIssuer
          ? 1
          : b.origCheckIssuer > a.origCheckIssuer
          ? -1
          : 0
      );
    }

    const header = {
      reportName: 'Unallocated Balance Report list',
      fileName: exportFileName,
    };

    const options = {
      info: { firstInfo: '', secondInfo, fourthInfo, thirdInfo },
      titleName: 'Manufacture Name: ',
      mapping,
      pageSize: {
        height: 800,
        width: 2000,
      },
    };
    let paginationArr = [];
    const widths = [];
    if (exportAllClicked) {
      setExportAllClicked(false);
      const sordtedKeys = Object.keys(groupedData);
      sordtedKeys.sort();
      paginationArr = sordtedKeys;
      exportAllPDF(
        header,
        groupedData,
        columnApi,
        userDefaults,
        options,
        paginationArr,
        widths,
        logInUser
      );
    }
  }, [exportAllDataValue]);
  const onGridReady = (params) => {
    setColumnApi(params.columnApi);
  };
React.useEffect(() => {
  const data = searchResult.map((val) => {
    return {
      ...val,
      unallocatedBalanceAmt: val.unallocatedBalanceAmt
        ? val.unallocatedBalanceAmt
        : `$ ${parseFloat(0).toFixed(2)}`,
      origReceivedDt: val.origReceivedDt
        ? moment(val.origReceivedDt, 'DD-MMM-YYYY').format('MM/DD/YYYY')
        : val.origReceivedDt,
      allocatedReceivedDt: val.allocatedReceivedDt
        ? moment(val.allocatedReceivedDt, 'DD-MMM-YYYY').format('MM/DD/YYYY')
        : val.allocatedReceivedDt,
      allocatedCheckLogNum: val.allocatedCheckLogNum || '',
      origCheckLogNum: val.origCheckLogNum || '',
    };
  });

  const sortedData = [
    ...data
      .filter(item => item.currInEffectInd === 0)
      .sort((a, b) =>
        moment(b.origReceivedDt, 'MM/DD/YYYY').valueOf() -
        moment(a.origReceivedDt, 'MM/DD/YYYY').valueOf()
      ),
    ...data
      .filter(item => item.currInEffectInd === 1)
      .sort((a, b) =>
        moment(b.origReceivedDt, 'MM/DD/YYYY').valueOf() -
        moment(a.origReceivedDt, 'MM/DD/YYYY').valueOf()
      )
  ].map(item => ({
    ...item,
    origReceivedDt: moment(item.origReceivedDt, 'MM/DD/YYYY').format('MM/DD/YYYY'),
    allocatedReceivedDt: item.allocatedReceivedDt
      ? moment(item.allocatedReceivedDt, 'MM/DD/YYYY').format('MM/DD/YYYY')
      : item.allocatedReceivedDt
  }));

  setRows(sortedData);
}, [searchResult]);


  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator
        parent1="Detail Reports"
        parent2="Display Unallocated Balance"
      />

      <DisplayErrorMessages errorMessages={errorMessages} />
      <div className="tab-body">
        {!fullScreenView && (
          <>
            <div className="row">
              <div className="col-12  ">
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="row mb-5">
                      <div className="col-12">
                        <div className="float-right">
                          <PaginationBox
                            array={paginationArray}
                            count={count}
                            handleClick={handleClick}
                            handleBlur={handleBlur}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col-4">
                        <TextField
                          label="Manufacture Id : "
                          id="Manufacture Id "
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={selectedRows[count - 1]?.mfgId}
                        />
                      </div>
                      <div className="col-4">
                        <TextField
                          label="Balance Status : "
                          id="Balance Status"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={
                            used && unused
                              ? 'Used, Unused'
                              : used
                              ? 'Used'
                              : unused
                              ? 'Unused'
                              : ''
                          }
                        />
                      </div>
                      <div className="col-4">
                        <TextField
                          label="Balance Type: "
                          id="Balance Type"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={
                            lcb && opmt
                              ? 'LCB, OPMT'
                              : lcb
                              ? 'LCB'
                              : opmt
                              ? 'OPMT'
                              : ''
                          }
                        />
                      </div>

                      <div className="col-6 mb-3">
                        <TextField
                          label="Manufacture Name : "
                          id="Manufacture Name"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled
                          value={selectedRows[count - 1]?.mfgName}
                        />
                      </div>
                      <div className="col-6 mb-3">
                        <TextField
                          label="Rebate Program : "
                          id="Rebate Program"
                          fullWidth
                          placeholder=""
                          InputLabelProps={{
                            shrink: true,
                          }}
                          name="RebateProgram"
                          value={rebateProgramNameValue}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="row" style={{ marginTop: 15 }}>
          <div className="unallocated" style={{ width: '100vw' }}>
            <TableGridWithFeatures
              gridCall={onGridReady}
              gridHeight={viewPortHeight_355}
              columnDefs={UnallocatedBalanceReportTableHead}
              rowData={rows?.length > 0 ? rows : []}
              showSearchInfo
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              enterMovesDown
              isScrollOn
              defaultColWidth={200}
              showResetFilter={false}
              defaultCol={{
                wrapHeaderText: true,
              }}
              countValue={count}
              frameworkComponents={{
                TextBoxRender: (cellInfo) => {
                  const name = cellInfo?.value;

                  if (name && name.length > 17) {
                    return (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="labeler-tooltip">{name}</Tooltip>}
                      >
                        <div>{name}</div>
                      </OverlayTrigger>
                    );
                  }
                  return <div>{name}</div>;
                },
              }}
              noGlobalSort
              hideTotalCount={false}
              exportFile
              exportAllTpPDF={exportAllTpPDF}
              fileName="UnallocatedBalance"
              reportName="Unallocated Balance Report"
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={changeFullScreenView}
              info={{ firstInfo, secondInfo, thirdInfo, fourthInfo }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default UnallocatedBalanceDisplay;
